import { render, staticRenderFns } from "./VizionQuestion.vue?vue&type=template&id=4825662a&scoped=true&"
import script from "./VizionQuestion.vue?vue&type=script&lang=js&"
export * from "./VizionQuestion.vue?vue&type=script&lang=js&"
import style0 from "./VizionQuestion.vue?vue&type=style&index=0&id=4825662a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4825662a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VContainer,VRow,VTextField})
